
export const GET_USER_ACCOUNT_DATA_SUCCESS = 'GET_USER_ACCOUNT_DATA_SUCCESS';
export const GET_USER_ACCOUNT_DATA_ERROR = 'GET_USER_ACCOUNT_DATA_ERROR';

export const UPDATE_USER_ACCOUNT_DATA_SUCCESS = 'UPDATE_USER_ACCOUNT_DATA_SUCCESS';
export const UPDATE_USER_ACCOUNT_DATA_ERROR = 'UPDATE_USER_ACCOUNT_DATA_ERROR';

